//集中项目所有接口的apis.js

import axios from './$http';
import base from './base';

const apis = {
  //抽奖功能转盘
  getPrizeDrawApi(hisId, num = '') {
    return axios.post(`/online/index/prizeDraw?hisId=${hisId}&num=${num}`);
  },
  //获取用户个人信息
  getUserInfoApi() {
    return axios.get(`/online/index/userInfo`);
  },
  //获取楼栋信息
  getParkAllInfoApi(hisId) {
    return axios.get(`/online/wxPark/build?hisId=${hisId}`);
  },
  //车位列表数据
  getParkAllListApi(params) {
    return axios.post(`/online/wxPark/wxParkList`, params);
  },
  //车位详情
  getParkDetailApi(wxParkId, isAdd = 0) {
    return axios.get(`/online/wxPark/view?wxParkId=${wxParkId}&isAdd=${isAdd}`);
  },
  //报名--废弃
  signUp(paramsData) {
    return axios.post(`/online/wxPark/signUp`, paramsData);
  },
  //活动类型：1报名，2.带看,3.砸金蛋
  takeLookRegister(params) {
    return axios.post(`/online/index/visitPrizeDraw`, params);
  },
  //获取活动列表
  getActivityListApi(hisId, uid) {
    return axios.get(`/online/index/wxCarouselList?hisId=${hisId}&uid=${uid}`);
  },
  //确认报名
  confirmRegisterApi(params) {
    return axios.post(`/online/index/registration`, params);
  },
  /* 直播相关 */
  //获取userSign
  genTestUserSigApi(uid) {
    return axios.get(`/online/live/genTestUserSig?uid=${uid}`);
  },
  //直播间列表
  getLiveListApi(hisId) {
    return axios.get(`/online/live/liveList?hisId=${hisId}`);
  },
  //直播间点赞
  setLiveGives(params) {
    return axios.post(`/online/live/liveUp`, params);
  },
  //获取直播间点赞数
  getLiveGives(liveId) {
    return axios.get(`/online/live/liveUpNum?liveId=${liveId}`);
  },
  //埋点
  burialPointSetApi(params) {
    return axios.post('/online/index/buryingPoint', params);
  },
  //直播日志
  liveLogApi(params) {
    return axios.post('/online/live/liveLogUpdate', params);
  },
  //获取项目信息
  getProjectInfoApi(hisId) {
    return axios.get(`/online/index/projectInfo?hisId=${hisId}`);
  },
  //获取项目字典信息
  getDictApi(type) {
    return axios.get(`/online/index/dictList?type=${type}`);
  },
  //获取直播详情--福袋红包配置信息
  getLiveDetailApi(liveId) {
    return axios.get(`/online/live/liveDetail?liveId=${liveId}`);
  },
  //直播红包抽奖
  liveRedPacketApi(params) {
    return axios.post(`/online/live/prizeDraw`, params);
  },
  //直播福袋抽奖 type7
  liveFuDaiApi(params) {
    return axios.post(`/online/live/visitPrizeDraw`, params);
  },
  //直播抽奖信息
  livePrizeInfoApi(liveId) {
    return axios.get(`/online/live/liveCj?liveId=${liveId}`);
  },
  //设置直播累计人数
  liveSetCountApi(params) {
    return axios.post(`/online/live/liveAddNum`, params);
  },
  //直播聊天埋点
  liveChatLogApi(params) {
    return axios.post(`/online/live/liveChat`, params);
  },
  //获取投票活动详情列表
  getVoteListApi(groupId, uid, keyword, hisId) {
    return axios.get(`/online/wx/info/voteList?groupId=${groupId}&uid=${uid}&hisId=${hisId}&keyword=${keyword}`);
  },
  //进行投票
  voteAddApi(params) {
    return axios.post(`/online/wx/info/addVote`, params);
  }
};

export default apis;



// WEBPACK FOOTER //
// ./src/request/apis.js